import React, { useEffect, useState } from "react";
import { Box, Button, Modal, Typography, TextField } from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import NoEncryptionGmailerrorredIcon from "@mui/icons-material/NoEncryptionGmailerrorred";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { validateCUITCUIL, handleCuitChange } from "../helpers/useCuit";
import { generarFacturaInfo } from "../helpers/generarFacturaInfo"; // Importa la función
import { FiAlertCircle } from "react-icons/fi"; // Importa el ícono
import { useProductStore } from "../hooks";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import fullImg from "../images/fullSinFondo.svg";
import tiendaImg from "../images/tienda.svg";

const Sidebar = ({ handleFacturaElectronica, handleDeleteAll, clientePercepciones }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { productos } = useProductStore();
  const [condicion, setCondicion] = useState("CONTADO");
  const [showModal, setShowModal] = useState(false);
  const [cuit, setCuit] = useState("");
  const [cuitError, setCuitError] = useState(false);
  const solicitarAforadores = localStorage.getItem("solicitarAforadores");
  const habilitaTiendaFull = JSON.parse(localStorage.getItem("habilitaTiendaFull")) || false;
  const [cliente, setCliente] = useState(null);

  useEffect(() => {
    const cliente = localStorage.getItem("cliente") ? JSON.parse(localStorage.getItem("cliente")) : null;
    const condicionVenta = cliente?.condicionVenta?.condicionVentaContado ?? null;
    const condicionVentaStorage = localStorage.getItem("condicionVenta");

    if (condicionVenta == true) {
      setCondicion(condicionVenta);
      console.log(condicionVenta);
      localStorage.removeItem("condicionVenta");
    } else if (condicionVentaStorage) {
      setCondicion(condicionVenta);
      localStorage.removeItem("condicionVenta");
    } else if (cliente) {
      setCliente(cliente);
      localStorage.removeItem("condicionVenta");
      setCondicion(condicionVenta ? "CONTADO" : "CTA. CTE.");
    }
  }, []);

  useEffect(() => {
    const handleClienteChange = () => {
      const cliente = localStorage.getItem("cliente") ? JSON.parse(localStorage.getItem("cliente")) : null;
      const condicionVenta = cliente?.condicionVenta?.condicionVentaContado;
      setCliente(cliente);
      setCondicion(condicionVenta === false ? "CTA. CTE." : "CONTADO");
    };

    window.addEventListener("clienteChanged", handleClienteChange);

    return () => {
      window.removeEventListener("clienteChanged", handleClienteChange);
    };
  }, []);

  const limiteAfip = parseFloat(localStorage.getItem("limite"));

  const buttonStyle = {
    backgroundColor: theme.bandera.colorPrimario,
    color: "white",
    padding: "10px",
    marginTop: "5px",
    marginRight: "40px",
    "&:hover": {
      backgroundColor: theme.bandera.colorSecundario,
    },
  };

  const iconStyle = {
    fontSize: "58px",
  };

  const handlePagoClick = () => {
    console.log(condicion);
    const facturaInfo = generarFacturaInfo(productos, cliente);
    localStorage.setItem("facturaInfo", JSON.stringify(facturaInfo));
    if (limiteAfip < parseFloat(facturaInfo.total).toFixed(2) && !localStorage.getItem("cliente")) {
      setShowModal(true);
    } else {
      if (condicion == "CTA. CTE.") {
        handleFacturaElectronica();
      } else {
        navigate("/contrapage");
      }
    }
  };

  const handleModalAccept = () => {
    if (validateCUITCUIL(cuit.replace(/-/g, ""))) {
      setShowModal(false);
      localStorage.setItem("cuit", cuit);
      navigate("/contrapage");
    } else {
      setCuitError(true);
    }
  };

  const handleModalCancel = () => {
    setShowModal(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "white",
        marginTop: "10px",
        // height: window.innerWidth > 1000 ? "60vh" : "100vh",
        width: "70px",
        position: "fixed",
        right: window.innerWidth > 1000 ? 10 : 0,
      }}
    >
      {/* ARTICULOS */}
      <Button variant="contained" sx={buttonStyle} onClick={() => navigate("/articulossearchpage")}>
        <StickyNote2OutlinedIcon sx={iconStyle} />
      </Button>
      {/* TIENDA FULL*/}
      {habilitaTiendaFull && (
        <Button variant="contained" sx={{...buttonStyle, bgcolor:'#fff', border:'2px solid #000'}} onClick={() => navigate("/tiendapage")}>
            <img
              src={theme.bandera.tiendaLogo}
              style={{
                width: 56,
                height: 56,
              }}
            />
        </Button>
      )}
      {/* DESPACHOS */}
      {solicitarAforadores == "true" && (
        <Button variant="contained" sx={buttonStyle} onClick={() => navigate("/DespachosSearchPage")}>
          <LocalGasStationIcon sx={iconStyle} />
        </Button>
      )}
      {/* CLIENTES F4 */}
      <Button variant="contained" sx={buttonStyle} onClick={() => navigate("/clientessearchpage")}>
        <PersonOutlineOutlinedIcon sx={iconStyle} />
      </Button>
      {/* PAGAR F2 */}
      <Button
        variant="contained"
        sx={buttonStyle}
        onClick={handlePagoClick}
        disabled={productos.length === 0 || (cliente && localStorage.getItem("percepciones") === "true" && clientePercepciones === 0)}
      >
        {condicion === "CTA. CTE." ? <PointOfSaleIcon sx={iconStyle} /> : <CreditCardOutlinedIcon sx={iconStyle} />}
      </Button>

      {/* BORRAR TODO F11 */}
      <Button variant="contained" sx={buttonStyle} onClick={handleDeleteAll}>
        <DeleteOutlinedIcon sx={iconStyle} />
      </Button>

      <Modal open={showModal} onClose={handleModalCancel}>
        <Box
          sx={{
            "& .MuiDialog-paper": {
              padding: theme.spacing(1),
              backgroundColor: theme.palette.background.default,
              boxShadow: theme.shadows[5],
              borderRadius: theme.shape.borderRadius,
              display: "flex",
              flexDirection: "column",
            },
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: theme.spacing(2),
            }}
          >
            <FiAlertCircle size={48} color={theme.palette.info.main} />
          </Box>
          <Typography sx={{ mt: 2, fontSize: 18, fontWeight: 100 }}>Se debe identificar al consumidor final para este importe.</Typography>
          <Typography sx={{ fontSize: 14, fontWeight: 100 }}>Importe máximo: ${limiteAfip}</Typography>
          <Typography sx={{ mt: 2, fontSize: 18, fontWeight: 100 }}>Ingrese un CUIT válido:</Typography>
          <TextField
            label="CUIT"
            value={cuit}
            variant="outlined"
            fullWidth
            sx={{ mb: 4, mt: 2 }}
            onChange={event => handleCuitChange(event, setCuit, setCuitError)}
            error={cuitError}
            helperText={cuitError ? "CUIT debe tener 11 dígitos y ser válido" : ""}
            InputLabelProps={{
              style: { fontSize: "0.85rem", color: "gray" },
            }}
          />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button onClick={handleModalCancel} color="primary" variant="contained" sx={{ mr: 1 }}>
              <Typography variant="body1" style={{ fontSize: "16px", fontWeight: 500 }}>
                Cancelar
              </Typography>
            </Button>
            <Button onClick={handleModalAccept} color="primary" variant="contained">
              <Typography variant="body1" style={{ fontSize: "16px", fontWeight: 500 }}>
                Aceptar
              </Typography>
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Sidebar;
